export default function capitalized(text) {
  return text.charAt(0).toUpperCase() + text.substring(1);
}
